import { createAction, props } from '@ngrx/store';

export const broadcast = createAction('[Broadcast]: Event', props<{ key: string; data: unknown }>());
export const broadcastSuccess = createAction('[Broadcast]: Success');
